/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export type TestStatusEnum = 'Not started' | 'Started' | 'Passed' | 'Failed' | 'Ineligible' | '11184809';

export const TestStatusEnum = {
  NOT_STARTED: 'Not started' as TestStatusEnum,
  STARTED: 'Started' as TestStatusEnum,
  PASSED: 'Passed' as TestStatusEnum,
  FAILED: 'Failed' as TestStatusEnum,
  INELIGIBLE: 'Ineligible' as TestStatusEnum,
  UNKNOWN_DEFAULT_OPEN_API: '11184809' as TestStatusEnum
};
